import React from 'react';
import clsx from 'classnames';
import './index.css';
import { Position } from 'components';
import Introduction from './components/Introduction';
import ServiceSystem from './components/ServiceSystem';
import Honor from './components/Honor';
import { usePageTitle } from '../../hooks';

const Blurb = () => {
  // 设置页面标题
  usePageTitle('关于之阳');
  const bannerList = [
    {
      img: '/img/blurbBig.jpg',
      className: 'blurb-top-banner-big',
    },
    {
      img: '/img/blurbSmall.jpg',
      className: 'blurb-top-banner-small',
    },
  ];

  return (
    <div
      className={clsx('blurb-top')}
      style={{ minHeight: window.innerHeight }}
    >
      {/* 顶部banner */}
      {bannerList.map((item, index) => (
        <img
          key={index}
          src={item.img}
          alt=''
          width={'100%'}
          height={'100%'}
          className={clsx(item.className)}
        />
      ))}
      {/* 当前位置 */}
      <Position list={['首页', '关于之阳']} />
      {/* 公司简介 */}
      <Introduction />
      {/* 服务体系 */}
      <ServiceSystem />
      {/* 荣誉资质 */}
      <Honor />
    </div>
  );
};

export default Blurb;
